import { render, staticRenderFns } from "./customerCases.vue?vue&type=template&id=34f4b38e&scoped=true"
import script from "./customerCases.vue?vue&type=script&lang=js"
export * from "./customerCases.vue?vue&type=script&lang=js"
import style0 from "./customerCases.vue?vue&type=style&index=0&id=34f4b38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f4b38e",
  null
  
)

export default component.exports